import React, { useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { saveNote, addCount } from 'services/notes.service';
import { useSelector } from 'react-redux';
import MessageView from '../components/view/MessageView';
import MetaTags from '../components/MetaTags';

const NoteView = ({
  match: {
    params: { id },
  },
}) => {
  const [liked, setLiked] = useState(false);
  const [emojiReactionsVisible, setEmojiReactionsVisible] = useState();
  const note = useSelector((state) => state.notes.data[id]);

  useEffect(() => {
    if (emojiReactionsVisible) {
      setTimeout(() => {
        setEmojiReactionsVisible(false);
      }, 4000);
    }
  }, [emojiReactionsVisible]);

  useEffect(() => {
    addCount(id, 'visits');
  }, []);

  function onCTAClick() {
    addCount(id, 'clicks');
  }

  function onLike() {
    if (!liked) {
      setLiked(true);
      addCount(id, 'likes');
    }
  }

  if (!note) {
    return (
      <Box>
        <Alert severity="error">Note not found.</Alert>
      </Box>
    );
  }

  const onEmojiReaction = (emoji) => {
    setEmojiReactionsVisible(emoji);
    saveNote({
      counter: emoji,
      change: '1',
      hash: note.hash,
    });
  };

  // legacy text to html
  note.notes_text = note.notes_text.startsWith('<')
    ? note.notes_text
    : note.notes_text.replace(/\n/g, '<br />');

  return (
    <Box>
      <MetaTags data={note} />
      <MessageView
        containerStyle={{ minHeight: '100vh', overflow: 'hidden' }}
        isPreview={false}
        onReaction={onEmojiReaction}
        onCTAClick={onCTAClick}
        message={note}
      />
    </Box>
  );
};

export default NoteView;
